/* WSI — case-minimum guard, enforced in the cart.
   2026-08-18: ice cream 50-case minimum.
   2026-09-01: generalised to RULES so the dry Pallet Case builder gets the same
   protection; checkout is disabled while ANY rule is short (the old single-rule
   code would have re-enabled checkout from the other rule's ok-branch). */
(function () {
  var RULES = window.WSI_CASE_RULES;
  if (!RULES || !RULES.length) {
    var L = window.WSI_ICE || { min: 50, ids: [], url: '/pages/build-your-ice-cream-pallet' };
    RULES = [{ key: 'ice', min: L.min || 50, ids: L.ids || [], type: L.type || 'Ice Cream',
               url: L.url, lead: 'Frozen goods ship by the pallet.' }];
  }
  RULES.forEach(function (r) {
    r._ids = {};
    (r.ids || []).forEach(function (id) { r._ids[String(id)] = 1; });
  });

  function casesFor(rule, cart) {
    var n = 0;
    (cart.items || []).forEach(function (li) {
      var hit = rule._ids[String(li.product_id)] || (rule.type && li.product_type === rule.type);
      if (hit) n += li.quantity;
    });
    return n;
  }

  function checkoutEls() {
    var sel = [
      'button[name="checkout"]', 'input[name="checkout"]', '#checkout',
      '.cart__checkout-button', '[data-testid="Checkout-button"]',
      'form[action*="/cart"] [type="submit"][name="checkout"]'
    ].join(',');
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  /* The header's add-to-cart popup holds a form[action="/cart"] too, and it comes first in the page,
     so one querySelector list used to drop these notes into that hidden popup: shoppers saw a
     disabled checkout with no explanation. The notes belong on the cart page only. */
  function hostEl() {
    if (!/^\/cart\/?$/.test(location.pathname)) return null;
    return document.querySelector('main cart-items') || document.querySelector('main .cart__items') ||
      document.querySelector('main form[action*="/cart"]') || document.querySelector('main');
  }

  function banner(rule, short) {
    var id = 'wsi-min-warn-' + rule.key, old = document.getElementById(id);
    if (!short) { if (old) old.remove(); return; }
    var html =
      '<strong>' + rule.lead + '</strong> Your cart has ' + short.have +
      ' case' + (short.have === 1 ? '' : 's') + ' — a minimum of ' + rule.min +
      ' is required. Add ' + short.need + ' more to check out.' +
      ' <a href="' + rule.url + '" style="color:#4DE5CC;font-weight:700;text-decoration:underline">Open the pallet builder &rarr;</a>';
    if (old) { old.innerHTML = html; return; }
    var d = document.createElement('div');
    d.id = id;
    d.setAttribute('role', 'alert');
    d.style.cssText = 'margin:14px 0;padding:15px 18px;border:1px solid rgba(236,93,153,.45);' +
      'background:rgba(236,93,153,.07);border-radius:14px;font-size:15px;line-height:1.55;color:#eaeaea';
    d.innerHTML = html;
    var host = hostEl();
    if (host) host.insertBefore(d, host.firstChild);
  }

  function notice() {
    if (document.getElementById('wsi-ice-note')) return;
    var d = document.createElement('div');
    d.id = 'wsi-ice-note';
    d.style.cssText = 'margin:14px 0;padding:15px 18px;border:1px solid rgba(77,229,204,.5);' +
      'background:rgba(77,229,204,.09);border-radius:14px;font-size:14.5px;line-height:1.6;color:#eaeaea';
    d.innerHTML = '<strong>Shipping is free — no freight charge.</strong> Pallet orders ship free of ' +
      'charge, and a WSI representative will reach out to confirm your order before anything ships.';
    var host = hostEl();
    if (host) host.insertBefore(d, host.firstChild);
  }

  function apply(cart) {
    var anyShort = false, anyAtMin = false;
    RULES.forEach(function (r) {
      var have = casesFor(r, cart);
      if (have > 0 && have < r.min) {
        anyShort = true;
        banner(r, { have: have, need: r.min - have });
      } else {
        banner(r, null);
        if (have >= r.min) anyAtMin = true;
      }
    });
    var els = checkoutEls();
    if (anyShort) {
      els.forEach(function (b) {
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.style.opacity = '.45';
        b.style.cursor = 'not-allowed';
        if (!b.dataset.wsiIceBound) {
          b.dataset.wsiIceBound = '1';
          b.addEventListener('click', function (e) {
            if (b.disabled || b.getAttribute('aria-disabled') === 'true') {
              e.preventDefault(); e.stopImmediatePropagation();
              var w = document.querySelector('[id^="wsi-min-warn-"]');
              if (w) w.scrollIntoView({ behavior: 'smooth', block: 'center' });
              else location.href = '/cart';   // the explanation lives on the cart page
            }
          }, true);
        }
      });
    } else {
      els.forEach(function (b) {
        if (b.dataset.wsiIceBound) { b.disabled = false; b.removeAttribute('aria-disabled'); b.style.opacity = ''; b.style.cursor = ''; }
      });
      if (anyAtMin) notice();
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();
  /* cart drawer / quantity changes re-render the DOM — re-check */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="checkout"], .cart__checkout-button, cart-remove-button, .cart-item__quantity')) setTimeout(refresh, 700);
  }, true);
  new MutationObserver(function () { clearTimeout(window.__wsiIceT); window.__wsiIceT = setTimeout(refresh, 400); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
